import React from "react";

import { FieldTeamVisibility } from "@mapmycustomers/shared/enum/FieldVisibility";
import Role from "@mapmycustomers/shared/types/Role";
import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";

import RolesVisibilityList from "./RolesVisibilityList";
import styles from "./RoleVisibility.module.scss";

interface Props {
  calculatedField?: boolean;
  disabledFieldVisibilities?: FieldTeamVisibility[];
  onChange?: (value: Record<Role["id"], FieldTeamVisibility>) => void;
  phiEnabled?: boolean;
  schemaField?: SchemaField;
  value?: Record<Role["id"], FieldTeamVisibility>;
  visible: boolean;
}

const RoleVisibility: React.FC<Props> = ({
  calculatedField,
  disabledFieldVisibilities,
  onChange,
  phiEnabled,
  schemaField,
  value,
  visible,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div className={styles.container}>
      <RolesVisibilityList
        calculatedField={calculatedField}
        disabledFieldVisibilities={disabledFieldVisibilities}
        onChange={onChange}
        phiEnabled={phiEnabled}
        schemaField={schemaField}
        value={value}
      />
    </div>
  );
};

export default RoleVisibility;
